// extracted by mini-css-extract-plugin
module.exports = {"tag":"WebTag_tag__360Et"};